export enum LoginConstants {
  RESET_LOGIN = 'login/RESET_LOGIN',
  SET_LOGIN_FAILED = 'login/SET_LOGIN_FAILED',
  SET_AUTHENTICATION_JWT = 'login/SET_AUTHENTICATION_JWT',
  SET_LOGIN_PHASE_IS_LOADING = 'login/SET_LOGIN_PHASE_IS_LOADING',
  SET_USER_VERIFY_ERROR_TEXT = 'login/SET_USER_VERIFY_ERROR_TEXT',
  SET_LOGIN_CALLBACK_URL = 'login/SET_LOGIN_CALLBACK_URL',
}
